import {TranslateService} from "@ngx-translate/core";
import {SelectOptionsComponent} from "../../../framework/entity/select/options/select-options.component";
import {Component, forwardRef} from "@angular/core";
import {AccountDetailsData} from "../account.data";

@Component({
    selector: "wbo-account-limit-duration-select-options",
    templateUrl: "./account-limit-duration-select-options.component.html",
    providers: [{
        provide: SelectOptionsComponent,
        useExisting: forwardRef(() => AccountLimitDurationSelectOptionsComponent),
        multi: true
    }]
})
export class AccountLimitDurationSelectOptionsComponent extends SelectOptionsComponent {
    AccountDetailsData = AccountDetailsData;

    constructor(translateService: TranslateService) {
        super(translateService);
    }
}
